import Region from '../components/views/region/Region.vue'
import RegionCreate from '../components/views/region/RegionCreate.vue'
import RegionDetail from '../components/views/region/RegionDetail.vue'

const routes = [{
        path: 'ga',
        component: Region,
        name: 'Region',
        meta: {
            description: 'List of Think Gas Geographical Areas',
            title: 'Geographical Areas',
            requiresAuth: true
        }
    },

    {
        path: 'ga/create',
        component: RegionCreate,
        name: 'RegionCreate',
        meta: {
            description: 'Add a new G.A',
            title: 'Add Geographical Area',
            requiresAuth: true
        }
    },
    {
        path: '/ga/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: 'RegionCreate' }) : next()
        },
        component: RegionDetail,
        name: 'RegionDetail',
        meta: {
            description: 'Details for the selected G.A',
            title: 'Update Geographical Area',
            requiresAuth: true
        }
    },
]


export default routes


// WEBPACK FOOTER //
// ./src/routes/region.route.js